import { t as __t } from "i18next";
import React, { useState, useEffect } from "react";
import { notifyListRefresh } from "../../../utils/listNavigation";
import { useDispatch } from "react-redux";
import { callAddVehicleBrand, callEditVehicleBrand, callGetVehicleBrandById } from "../../../api/settings/service";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import BackPrevious from "../../../components/back-previous";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import { handleInput, handleInvalid } from "../../../utils/commonUtil";
import { toast } from "react-toastify";
import "../../../components/i18n/lang";
import { decodeBase64 } from "../../../utils/commonUtil"
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import colors from '../../../utils/colors'

const Index = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [vehicleBrand, setVehicleBrand] = useState({ brandId: null, brandName: '', brandNameEn: '' });
	let params = useParams();

	useEffect(() => {
		if (Object.keys(params).length > 0) {
			let brandId = decodeBase64(params?.id)
			console.log(brandId)
			if (brandId != null) {
				getVehicleBrandById(brandId)
			}
		}
	}, []);

	const getVehicleBrandById = async (brandId) => {
		try {
			const rsp = await dispatch(callGetVehicleBrandById({ brandId }));
			console.log(rsp)
			if (rsp?.payload?.responseCode === "00000") {
				const item = rsp?.payload?.data
				setVehicleBrand((prev) => ({
					...prev,
					brandId: brandId,
					brandName: item.brandName || '',
					brandNameEn: item.brandNameEn || ''
				}));
			}
		} catch (error) {
			console.error(error)
		}
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setVehicleBrand({
			...vehicleBrand,
			[name]: value,
		});
	};

	const handleSave = async (e) => {
		e.preventDefault()

		Swal.fire({
			title: t("titleSave"),
			text: t("confirmSave"),
			icon: "warning",
			reverseButtons: true,
			showCancelButton: true,
			confirmButtonColor: colors.confirmMessage,
			cancelButtonColor: colors.cancel,
			confirmButtonText: t('confirm'),
			cancelButtonText: t('cancel')
		}).then(async (result) => {
			if (result.isConfirmed) {
				try {
					if (vehicleBrand.brandId != null) {
						let req = {
							brandId: vehicleBrand.brandId,
							brandName: vehicleBrand.brandName,
							brandNameEn: vehicleBrand.brandNameEn
						}
						const res = await dispatch(callEditVehicleBrand(req));
						if (res?.payload?.responseCode === "00000") {
							Swal.fire({
								icon: "success",
								title: t("success.add"),
								confirmButtonColor: colors.confirmMessage,
								confirmButtonText: t('close'),
							}).then(function () {
								notifyListRefresh();
								navigate(-1);
							});
						} else {
							toast.error(res?.payload?.responseCode + " - " + res?.payload?.responseDescription, {
								position: "top-left"
							})
						}
					} else {
						let req = {
							brandName: vehicleBrand.brandName,
							brandNameEn: vehicleBrand.brandNameEn
						}
						const res = await dispatch(callAddVehicleBrand(req));
						if (res?.payload?.responseCode === "00000") {
							Swal.fire({
								icon: "success",
								title: t("success.add"),
								confirmButtonColor: colors.confirmMessage,
								confirmButtonText: t('close'),
							}).then(function () {
								notifyListRefresh();
								navigate(-1);
							});
						} else {
							toast.error(res?.payload?.responseCode + " - " + res?.payload?.responseDescription, {
								position: "top-left"
							})
						}
					}
				} catch (error) {
					Swal.fire(__t("uiText.text023"), __t("uiText.text024"), "error");
				}
			}
		});
	}

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<form onSubmit={handleSave}>
				<section className="user-dashboard">
					<div className="dashboard-outer">
						<div className="upper-title-box back-title-group">
							<BackPrevious />
							<h4>{Object.keys(params).length > 0 ? t("settings.vehicle.brand.edit") : t("settings.vehicle.brand.add")}</h4>
						</div>

						<div className="ls-widget">
							<div className="tabs-box">
								<div className="widget-content p-4">
									<div className="default-form">
										<div className="row">
											<div className="col-md-6 form-group">
												<label> {t('settings.vehicle.brand.name')} <span className="text-danger">*</span> </label>
												<input
													type="text"
													name="brandName"
													className="form-control-uld"
													placeholder={t('settings.vehicle.brand.name')}
													onInput={handleInput}
													onChange={handleChange}
													value={vehicleBrand.brandName}
													autoComplete="off"
													required />
											</div>
											<div className="col-md-6 form-group">
												<label> {t('settings.vehicle.brand.nameEn')}<span className="text-danger">*</span> </label>
												<input
													type="text"
													name="brandNameEn"
													className="form-control-uld"
													placeholder={t('settings.vehicle.brand.nameEn')}
													onInput={handleInput}
													onChange={handleChange}
													value={vehicleBrand.brandNameEn}
													autoComplete="off"
													required />
											</div>

											<div className="col-12 d-flex justify-content-center">
												<div className="m-3">
													<button className="theme-btn btn-style-one w-100" type="submit">
														<i className="fas fa-add"></i>&nbsp;{t("button.save")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</form>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
